import { Carousel } from 'antd';

type Props = {
    images?: string[];
}

export default function GalleryLivePreview({ images }: Props) {

    // Use passed images if available, otherwise fallback to hook data
    const finalImages = images ?? [];

    const displayCarousel = finalImages && finalImages.length > 0;

  return (
    <Carousel autoplay dots style={{ borderRadius: 16, overflow: 'hidden' , display: displayCarousel ? 'block' : 'none' }}>
      {finalImages.map((src:string, idx:number) => (
        <div key={idx}>
          <img src={src} alt={`slide-${idx}`} style={{ width: '100%', height: 360, objectFit: 'contain' }} />
        </div>
      ))}
    </Carousel>
  );
}
